module.exports = __webpack_public_path__ + "static/media/tutoriales_white.c25d77ea.svg";